import { API } from "@/lib/api";
import { Ribbon } from "@/components/Layout";
import { Download, Users, FileText, Activity, Wallet, Calendar } from "lucide-react";

const EXPORTS = [
  { kind: "patients", label: "Patients", icon: Users, desc: "Liste complète de la patientèle" },
  { kind: "factures", label: "Factures", icon: FileText, desc: "Toutes les factures émises (HT, TVA, TTC)" },
  { kind: "soins", label: "Soins", icon: Activity, desc: "Historique des fiches de soin" },
  { kind: "paiements", label: "Paiements", icon: Wallet, desc: "Tous les encaissements" },
  { kind: "rdvs", label: "Rendez-vous", icon: Calendar, desc: "Agenda complet des RDV" },
];

export default function PiloterExports() {
  const download = (kind) => {
    const t = localStorage.getItem("sx_token");
    fetch(`${API}/dashboard/export/${kind}`, { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => r.blob()).then((b) => { const u = URL.createObjectURL(b); const a = document.createElement("a"); a.href = u; a.download = `${kind}.csv`; a.click(); a.remove(); });
  };
  return (
    <div>
      <Ribbon groups={[{ name: "Exports", children: <span className="text-sm text-slate-500">Téléchargez vos listings au format CSV</span> }]} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {EXPORTS.map(({ kind, label, icon: Icon, desc }) => (
          <div key={kind} className="bg-white sx-card p-5 flex flex-col">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-lg bg-emerald-100 text-emerald-700 flex items-center justify-center"><Icon className="w-5 h-5" /></div>
              <div className="font-display font-semibold text-slate-900">{label}</div>
            </div>
            <p className="text-sm text-slate-500 flex-1">{desc}</p>
            <button data-testid={`export-${kind}`} onClick={() => download(kind)} className="mt-4 inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-lg bg-[#141821] text-white text-sm font-medium hover:bg-[#232833]"><Download className="w-4 h-4" />Télécharger le listing</button>
          </div>
        ))}
      </div>
    </div>
  );
}
